var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-main"},[_c('p',[_vm._v("©BYTEPLAY GAMES LIMITED ALL RIGHTS RESERVED.")]),_vm._v(" "),_c('p',[(_vm.data.privacy)?_c('router-link',{attrs:{"target":"_blank","to":_vm.data.url}},[_vm._v(_vm._s(_vm.data.privacy))]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39cf1a5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 